module.exports = __webpack_public_path__ + "img/0Q3A6289_L_BlackMatted_MockedUp.7cfb93d4.jpg";